import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const TextBox = styled.textarea`
  width: 100%;
  height: 150px;
  padding: 10px 20px;
  border: 0.75px solid var(--bg-back-button);
  border-radius: 3px;
  background-color: transparent;
  color: var(--text-color);
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.45;
  transition: border 250ms linear;

  @media ${device.desktop} {
    width: 75%;
    height: 80px;
    font-size: 10px;
    line-height: 1.6;
  }

  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    border: 0.75px solid var(--bg-button);
  }
`;
